export const CUSTOMER_DELIVERY_W4_READINESS_SECTIONS = Object.freeze([
  Object.freeze({
    id: 'benefits',
    title: 'Purchased-benefit summary',
    description: 'The portal may combine order, delivery, enrollment, and TMS-access status only from accepted owner projections. A matching email or paid redirect never creates access.',
    owner: 'Website aggregation · TMS Phase 8',
    gateIds: Object.freeze(['W0-ID-01', 'W0-ENT-01', 'W0-MIG-01', 'W0-REL-01']),
    actionEnabled: false,
  }),
  Object.freeze({
    id: 'deliveries',
    title: 'ZIP, PDF, and DOCX delivery',
    description: 'Mixed packages and individual documents require customer-bound grants, exact asset versions, protected delivery, and short-lived authorization—never public bucket paths.',
    owner: 'TMS Content · Phase 8',
    gateIds: Object.freeze(['W0-ID-01', 'W0-CONT-01', 'W0-ENT-01', 'W0-SVC-01', 'W0-MIG-01', 'W0-REL-01']),
    actionEnabled: false,
  }),
  Object.freeze({
    id: 'academy',
    title: 'MI Academy and webinars',
    description: 'Courses, prerecorded training, live YouTube webinar appointments, progress, and certificates require Content and entitlement contracts. W4 registers no progress or certificate operation yet.',
    owner: 'TMS Content/LMS · Phase 8',
    gateIds: Object.freeze(['W0-ID-01', 'W0-CONT-01', 'W0-ENT-01', 'W0-SVC-01', 'W0-MIG-01', 'W0-REL-01']),
    actionEnabled: false,
  }),
  Object.freeze({
    id: 'personal-provisioning',
    title: 'Personal TMS provisioning',
    description: 'Eligible purchases may request personal capabilities only after settlement. Activation waits for an idempotent TMS receipt and destination readback; readback and revoke operations still need registration.',
    owner: 'TMS Control · Phase 7',
    gateIds: Object.freeze(['W0-ID-01', 'W0-CAT-01', 'W0-PAY-01', 'W0-CONT-01', 'W0-ENT-01', 'W0-SVC-01', 'W0-REL-01']),
    actionEnabled: false,
  }),
  Object.freeze({
    id: 'launch',
    title: 'Entitlement-conditioned TMS launch',
    description: 'The website will request an audience-bound, expiring launch handoff only after effective permission readback. The canonical owner and launch model remain decisions, so no TMS URL is exposed.',
    owner: 'Owner and transport decision required',
    gateIds: Object.freeze(['W0-ID-01', 'W0-ENT-01', 'W0-LAUNCH-01', 'W0-SVC-01', 'W0-REL-01']),
    actionEnabled: false,
  }),
  Object.freeze({
    id: 'carrier-trial',
    title: 'Carrier trial and company verification',
    description: 'Trial eligibility, company information, privileged checkbox verification, provisioning, and readback need Carrier Workspace contracts. Only the launch-request operation is registered today.',
    owner: 'TMS Carrier Workspace · Phase 10',
    gateIds: Object.freeze(['W0-ID-01', 'W0-CAT-01', 'W0-PAY-01', 'W0-ENT-01', 'W0-LAUNCH-01', 'W0-TRIAL-01', 'W0-SVC-01', 'W0-REL-01']),
    actionEnabled: false,
  }),
  Object.freeze({
    id: 'office-suite',
    title: 'Office Suite editable copies',
    description: 'Editable paperwork belongs inside TMS for specifically entitled products and subscriptions. Editable-copy ownership, grant, suspension, and revoke operations are not registered yet.',
    owner: 'TMS Master + Carrier Workspace · Phases 9–10',
    gateIds: Object.freeze(['W0-ID-01', 'W0-CONT-01', 'W0-ENT-01', 'W0-SVC-01', 'W0-REL-01']),
    actionEnabled: false,
  }),
  Object.freeze({
    id: 'lifecycle',
    title: 'Lifecycle and reconciliation',
    description: 'Expiry, suspension, refunds, revocation, retries, and cross-ledger reconciliation must preserve payment, fulfillment, and effective-access states separately. Those commands and workers remain contract gaps.',
    owner: 'Owner contracts and release evidence required',
    gateIds: Object.freeze(['W0-ID-01', 'W0-PAY-01', 'W0-ENT-01', 'W0-SVC-01', 'W0-MIG-01', 'W0-REL-01']),
    actionEnabled: false,
  }),
]);
